<template>
<div class="flex-fill fill flex column">

    <div class="opt r">

        <div v-show="!comparingData" class="flex align-center">
            <input-range ref="rangeCompareInput" inputClass="secondary"
            v-if="comparingData && (Auth.role.indexOf('admin') > -1 || Auth.restrictions.view_transactions == 'ALL')"
            v-model="rangeCompare"
            @OnValueChanged="SearchCompare($event)"
            :largeDates="true"
            :icon="mobile ? 'datetime' : ''">
            </input-range>

            <input-range ref="rangeInput"
            :inputClass="isLocal ? 'secondary' : ''"
            :class="isLocal ? 'ml5' : 'flex-fill'"
            v-show="Auth.role.indexOf('admin') > -1 || Auth.restrictions.view_transactions == 'ALL'"
            v-model="range"
            @OnValueChanged="Search($event)"
            :largeDates="comparingData"
            :icon="mobile ? 'datetime' : ''">
            </input-range>
        </div>

        <i class="options icon-dots-vertical ml5"
        @click="Options([
            {text: 'Exportar', function: () => {stats.completed.length ? Export() : Info('No hay datos en este rango de tiempo')}, if: (!!(Auth.role.indexOf('admin') > -1) && isLocal), icon: 'download'},                                              
            {text: comparingData ? 'Dejar de Comparar Datos' : 'Comparar Datos', function: () => { if(!comparingData){ rangeCompare = PreviousYear(range); } comparingData = !comparingData; }, if: !!(Auth.role.indexOf('admin') > -1 || Auth.restrictions.view_transactions == 'ALL'), icon: 'comparation'},
            {text: 'Buscar Transacción', function: () => {modalTransactionSearch=true}, if: isLocal, icon: 'search'},
        ])"></i>
    </div>

    <!-- <div class="opt r" v-if="Local.type == 'FRANCHISE'">

        <input-range ref="range"
        v-if="(Auth.role.indexOf('admin') > -1 || Auth.restrictions.view_transactions == 'ALL')"
        class="flex-fill"
        v-model="range"
        @OnValueChanged="Search($event)">
        </input-range>

        <input-select
        ref="selectLocals"
        v-if="sublocals.length"
        v-show="desktop"
l        class="mr5"
        :items="sublocals"
        @OnValueChanged="LocalChanged($event)">
        </input-select>
        
        <i class="options icon-dots-vertical" @click="$refs.selectLocals.Open()"></i>
    </div> -->

    <tabs ref="tabs" v-if="tabs"
    class="flex-fill"
    :tabs="tabs"
    :keyByTab="true"
    v-model="currentTab"
    @OnTabPedidosOnline="SearchOnline(range)">

        <!-- General -->
        <div slot="General" class="fill flex"
            :style="{
                'flex-direction': mobile ? 'column' : 'row',
                'height': '100%',
                'overflow': 'hidden'
            }">
            <div v-for="(preview, previewIndex) in previews"
                :key="previewIndex"
                class="pa-body transactions-compare-panel"
                :style="comparingData ? {paddingTop: '0px !important'} : null"
                :class="{
                    'transactions-compare-panel--split-mobile': comparingData && mobile,
                    'transactions-compare-panel--divider-mobile': comparingData && previewIndex === 0 && mobile,
                    'transactions-compare-panel--divider-desktop': comparingData && previewIndex === 0 && !mobile
                }">

                    <div v-if="comparingData" class="bold ta-center pa10 mb15 selectable transactions-range-sticky"
                        @click="OpenRangeInput(previewIndex, $event)">
                        {{ FormatRange(previewIndex === 0 ? rangeCompare : range) }}
                    </div>

                    <!-- Transacciones Completadas -->
                    <div v-if="preview.stats && (preview.stats.completed.length > 0 || preview.stats.cancelled.length > 0)">

                        <div class="section mb20">
                            <chart
                            type="line"
                            :data="preview.stats.chartHistory"
                            dataset="total_money"
                            label="data"
                            height="200px"
                            :yLabelFormat="(value) => {return Util.Price(value, true)}"
                            :tooltip="(value, label, index) => {return `${Util.Price(value)}`}"
                            :customColor="[Util.Chart.purpleGradient]">
                            </chart>
                        </div>

                        <div class="flex column mb20">

                            <div class="hdvm mb10">
                                <div>
                                    <div :class="`section flex align-center ${isLocal && preview.stats.completed.length ? 'selectable' : ''} h100`" @click="isLocal ? $refs.list.Open(preview.stats.completed) : null">
                                        <avatar class="mr10"
                                        icon="bag"
                                        :color="Util.baseColors.green">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Total</div>
                                            <div class="secondary-text">{{Util.Number(preview.stats.completed.length)}} transacciones</div>
                                            <div class="secondary-text" v-if="preview.stats.completed.length">
                                                <span class="bold">Ticket Promedio</span> {{(Util.Price(Math.floor(preview.stats.total_money_customers_number/preview.stats.completed.length)))}}
                                            </div>
                                        </div>
                                        <div class="f18">{{Util.Price(preview.stats.total_money)}}</div>
                                    </div>
                                </div>

                                <div>
                                    <div :class="`section flex align-center ${isLocal && preview.stats.pending_payment.transactions.length ? 'selectable' : ''} h100`" @click="isLocal ? $refs.list.Open(preview.stats.pending_payment.transactions) : null">
                                        <avatar class="mr10"
                                        icon="hourglass"
                                        :color="Util.baseColors.yellow">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Pendiente</div>
                                            <div class="secondary-text">{{Util.Number(preview.stats.pending_payment.transactions.length)}} transacciones</div>
                                        </div>
                                        <div class="f18">{{Util.Price(preview.stats.pending_payment.total)}}</div>
                                    </div>
                                </div>

                            </div>
                            <div class="hdvm mb10">

                                <div v-if="isLocal">
                                    <div :class="`section flex align-center ${preview.stats.edited.length ? 'selectable' : ''} h100`" @click="$refs.list.Open(preview.stats.edited)">
                                        <avatar class="mr10"
                                        icon="edit"
                                        :color="Util.baseColors.yellow">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Editadas</div>
                                            <div class="secondary-text">Transacciones</div>
                                        </div>
                                        <div class="f18">{{Util.Number(preview.stats.edited.length)}}</div>
                                    </div>
                                </div>

                                <div v-if="isLocal">
                                    <div :class="`section flex align-center ${preview.stats.cancelled.length ? 'selectable' : ''} h100`" @click="detailsTransactionsCanceled(preview.stats.cancelled)">
                                        <avatar class="mr10"
                                        icon="forbidden"
                                        :color="Util.baseColors.red">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Canceladas</div>
                                            <div class="secondary-text">Transacciones</div>
                                        </div>
                                        <div class="f18 cred">{{Util.Number(preview.stats.cancelled.length)}}</div>
                                    </div>
                                </div>

                            </div>

                            <div class="hdvm mb10">
                                <div>
                                    <div :class="`section flex align-center h100 ${preview.stats.discount_transactions.length ? 'selectable' : ''}`" @click="$refs.list.Open(preview.stats.discount_transactions)">
                                        <avatar class="mr10"
                                        icon="discount"
                                        :color="Util.baseColors.yellow">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Descuentos</div>
                                            <div class="secondary-text">{{Util.Number(preview.stats.discount_transactions.length)}} transacciones</div>
                                        </div>
                                        <div class="f18">{{Util.Price(preview.stats.total_discount)}}</div>
                                    </div>
                                </div>
                                <div>
                                    <div :class="`section flex align-center h100 ${preview.stats.tips_transactions.length ? 'selectable' : ''}`" @click="$refs.list.Open(preview.stats.tips_transactions)">
                                        <avatar class="mr10"
                                        icon="coins"
                                        :color="Util.baseColors.yellow">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Propinas</div>
                                            <div class="secondary-text">{{Util.Number(preview.stats.tips_transactions.length)}} transacciones</div>
                                        </div>
                                        <div class="f18">{{Util.Price(preview.stats.total_tip)}}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="hdvm mb10">

                                <div>
                                    <div :class="`section flex align-center h100 ${preview.stats.delivery_transactions.length ? 'selectable' : ''}`" @click="$refs.list.Open(preview.stats.delivery_transactions)">
                                        <avatar class="mr10"
                                        icon="delivery"
                                        :color="Util.baseColors.blue">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Reparto</div>
                                            <div class="secondary-text">{{Util.Number(preview.stats.delivery_transactions.length)}} transacciones</div>
                                        </div>
                                        <div class="f18">{{Util.Price(preview.stats.total_delivery)}}</div>
                                    </div>
                                </div>

                                <div>
                                    <div :class="`section flex align-center h100 ${preview.stats.delivery_external_transactions.length ? 'selectable' : ''}`" @click="$refs.list.Open(preview.stats.delivery_external_transactions)">
                                        <avatar class="mr10"
                                        icon="cargo"
                                        :color="Util.baseColors.blue">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Reparto Externo</div>
                                            <div class="secondary-text">{{Util.Number(preview.stats.delivery_external_transactions.length)}} transacciones</div>
                                        </div>
                                        <div class="f18">{{Util.Price(preview.stats.total_delivery_external)}}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="hdvm mb10">
                                <div>
                                    <div :class="`section flex align-center h100 ${preview.stats.boletas.length ? 'selectable' : ''}`" @click="$refs.list.Open(preview.stats.boletas)">
                                        <avatar class="mr10"
                                        icon="invoice"
                                        :color="Util.baseColors.green">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Boletas</div>
                                            <div class="secondary-text"><span class="bold">Total</span> {{Util.Price(preview.stats.total_boleta)}}</div>
                                            <div class="secondary-text"><span class="bold">IVA</span> {{Util.Price(preview.stats.total_iva)}}</div>
                                        </div>
                                        <div class="f18">{{Util.Number(preview.stats.boletas.length)}}</div>
                                    </div>
                                </div>

                                <div>
                                    <div :class="`section flex align-center h100 ${preview.stats.boletas_rejected.length ? 'selectable' : ''}`" @click="$refs.list.Open(preview.stats.boletas_rejected)">
                                        <avatar class="mr10"
                                        icon="circle-exclamation"
                                        :color="Util.baseColors.red">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Rechazadas</div>
                                            <div class="secondary-text">Boletas</div>
                                        </div>
                                        <div class="f18 cred">{{Util.Number(preview.stats.boletas_rejected.length)}}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="hdvm" v-if="preview.stats.facturas">
                                <div>
                                    <div :class="`section flex align-center h100 ${preview.stats.facturas.length ? 'selectable' : ''}`" @click="$refs.list.Open(preview.stats.facturas)">
                                        <avatar class="mr10"
                                        icon="invoice"
                                        :color="Util.baseColors.green">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Facturas</div>
                                            <div class="secondary-text"><span class="bold">Total</span> {{Util.Price(preview.stats.facturas_total)}}</div>
                                            <div class="secondary-text"><span class="bold">IVA</span> {{Util.Price(preview.stats.facturas_total_iva)}}</div>
                                        </div>
                                        <div class="f18">{{Util.Number(preview.stats.facturas.length)}}</div>
                                    </div>
                                </div>

                                <div>
                                    <div :class="`section flex align-center h100 ${preview.stats.facturas.length ? 'selectable' : ''}`" @click="$refs.list.Open(preview.stats.facturas_rejected)">
                                        <avatar class="mr10"
                                        icon="circle-exclamation"
                                        :color="Util.baseColors.red">
                                        </avatar>
                                        <div class="flex-fill">
                                            <div class="bold">Rechazadas</div>
                                            <div class="secondary-text">Facturas</div>
                                        </div>
                                        <div class="f18 cred">{{Util.Number(preview.stats.facturas_rejected.length)}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="" v-if="preview.stats.completed.length > 0">
                            <div class="section mb10"
                            v-for="(group, groupIndex) in preview.stats.history"
                            :key="groupIndex">
                                <div class="flex fill align-center">
                                    <div class="percentage-icon relative" :style="{'background-color': dark ? '' : 'var(--gray-2)'}">
                                        <div :style="{'background-color': 'var(--purple)', 'border-radius': '50%', opacity: group.total_money / preview.stats.total_money}" class="fill"></div>
                                        <div :class="`absolute cw`">{{Percent(group.total_money, preview.stats.total_money)}}%</div>
                                    </div>
                                    <!--
                                    <avatar class="mr10" style="font-size: 12px"
                                    :color="Util.baseColors.purple"><span :style="{color: !dark ? 'black' : 'white'}">{{Percent(group.total_money, preview.stats.total_money)}}<span style="opacity: 0.5">%</span></span></avatar>
                                    -->
                                    <div class="flex flex-fill column">
                                        <div class="bold">{{group.data}}</div>
                                        <!--<div class="secondary-text"><span class="bold">Total:</span> {{Util.Price(group.total_money)}}</div>-->
                                        <div class="secondary-text"><span class="bold">Transacciones:</span> {{Util.Number(group.count)}}</div>
                                        <div class="secondary-text" v-if="Local.modules.module_tables"><span class="bold" >Cantidad de comensales:</span> {{Util.Number(group.customers_number)}}</div>
                                        <div class="secondary-text"><span class="bold">Ticket promedio:</span> {{Util.Price(Math.floor(group.average_ticket))}}</div>
                                    </div>
                                    <div class="bold">{{Util.Price(group.total_money)}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="secondary-text ta-center mt10" v-else>No hay datos</div>
                </div>
            </div>
        
        <!-- Items -->
        <div slot="Menu" class="fill flex"
            :style="{
                'flex-direction': mobile ? 'column' : 'row',
                'height': '100%',
                'overflow': 'hidden'
            }">
            <div v-for="(preview, previewIndex) in previews"
                :key="previewIndex"
                class="pa-body transactions-compare-panel"
                :style="comparingData ? {paddingTop: '0px !important'} : null"
                :class="{
                    'transactions-compare-panel--split-mobile': comparingData && mobile,
                    'transactions-compare-panel--divider-mobile': comparingData && previewIndex === 0 && mobile,
                    'transactions-compare-panel--divider-desktop': comparingData && previewIndex === 0 && !mobile
                }"
                v-if="preview && preview.stats">

                <div v-if="comparingData" class="bold ta-center pa10 mb15 selectable transactions-range-sticky"
                    @click="OpenRangeInput(previewIndex, $event)">
                    {{ FormatRange(previewIndex === 0 ? rangeCompare : range) }}
                </div>

            <div v-if="preview.stats && preview.stats.categories.length > 0">
                <div class="f18 mb20">Categorias</div>
                <div class="section hdvm mb20">
                    <chart class="mb10"
                    :data="preview.stats.chartCategories"
                    dataset="count"
                    type="pie"
                    :label="(data) => {return data.data}"
                    :singleDataset="false"
                    :maxDatasets="7"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    height="200px"
                    :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_categories)}%`}">
                    </chart>

                    <div class="scroll-container">
                        <div :class="`entry ${isLocal?'selectable':''}`"
                        v-for="(category, index) in preview.stats.categories"
                        :key="index"
                        @click="isLocal ? $refs.list.Open(category.transactions, null, {stats: true, label: category.data, total: category.total_money, color: Util.ChartColor(index, preview.stats.categories.length)}, 'categories') : null">
                            <div class="flex align-center fill">
                                <div class="percentage-icon cw" :style="{'background-color': Util.ChartColor(index, preview.stats.categories.length)}">{{Percent(category.count, preview.stats.total_categories)}}%</div>
                                <div class="flex column">
                                    <span class="bold">{{category.data}}</span>
                                    <div class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(category.transactions.length)}}</div>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold">{{Util.Price(category.total_money)}}</span>
                                <!--<i v-if="isLocal" class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div v-if="preview.stats && preview.stats.sections.length > 0" class="mb20">
                <div class="flex align-center mb20">
                    <div class="f18 flex-fill">Secciones</div>
                    <input-field inputClass="secondary"
                    v-model="searchSections"
                    placeholder="Buscar..."
                    pre="search"
                    cleareable
                    :icon="mobile ? 'search' : ''"
                    :timeout="200">
                    </input-field>
                </div>
                <div class="section hdvm">
                    <chart
                    :data="preview.stats.chartSections"
                    dataset="total_money"
                    type="pie"
                    :label="(data) => {return data.data}"
                    :singleDataset="false"
                    :maxDatasets="7"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    height="200px"
                    :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_sections)}%`}">
                    </chart>

                    <div class="scroll-container">
                        <div :class="`entry ${isLocal?'selectable':''}`"
                        v-for="(section, index) in preview.stats.sections"
                        :key="index"
                        v-show="Util.InString(section.data, searchSections)"
                        @click="isLocal ? $refs.list.Open(section.transactions, null, {prev_sections: section.data , sections: false, stats: true, label: section.data, total: section.total_money, color: Util.ChartColor(index, preview.stats.sections.length)}, 'sections') : null">
                            <!-- @click="isLocal ? $refs.list.Open(category.transactions, `Transacciones con ${category.data}`) : null" -->
                            <div class="flex align-center fill">
                                <div class="percentage-icon cw" :style="{'background-color': Util.ChartColor(index, preview.stats.sections.length)}">{{Percent(section.total_money, preview.stats.total_sections)}}%</div>
                                <span class="bold">{{section.data}}</span>
                                <div class="flex-fill"></div>
                                <span class="bold">{{Util.Price(section.total_money)}}</span>
                                <!-- <i v-if="isLocal" class="icon icon-arrow-right-o c4"></i> -->
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div v-if="preview.stats && preview.stats.items.length > 0" class="mb20">
                <div>
                    <div class="flex align-center mb20">
                        <div class="f18 flex-fill">Items <div class="secondary-text">Cantidad: {{Util.Sum(preview.stats.items, 'count')}}</div></div>
                        <input-field inputClass="secondary"
                        v-model="searchItems"
                        placeholder="Buscar..."
                        pre="search"
                        cleareable
                        :icon="mobile ? 'search' : ''"
                        :timeout="200">
                        </input-field>
                    </div>

                    <div class="section hdvm">
                        <chart
                        :data="preview.stats.chartItems"
                        dataset="total_money"
                        type="pie"
                        :label="(data) => {return data.data}"
                        :singleDataset="false"
                        :maxDatasets="7"
                        :showLegend="false"
                        :xLabelFormat="null"
                        :yLabelFormat="null"
                        :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_money)}%`}"
                        height="200px">
                        </chart>

                        <div class="scroll-container">
                            <div :class="`entry ${isLocal ? 'selectable' : ''}`"
                            v-for="(item, index) in preview.stats.items"
                            :key="index"
                            @click="isLocal ? $refs.list.Open(item.transactions, null, {prev_items: item.data, sections: false, items: false, stats: true, label: item.data, total: item.total_money, color: Util.ChartColor(index, preview.stats.items.length)}, 'items', ['Clientes']) : null"
                            v-show="Util.InString(item.data, searchItems)">
                                <div class="flex fill align-center">
                                    <div class="percentage-icon cw" :style="{'background-color':Util.ChartColor(index, preview.stats.items.length)}">{{Percent(item.total_money, preview.stats.total_money)}}%</div>
                                    <div class="flex column flex-fill">
                                        <span class="bold">{{item.data}}</span>
                                        <span class="secondary-text"><span class="bold">Cantidad: </span>{{Util.Number(item.count)}}</span>
                                        <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(item.transactions.length)}}</span>
                                    </div>
                                    <span class="bold mr10">{{Util.Price(item.total_money)}}</span>
                                    <!--<i v-if="isLocal" class="icon icon-arrow-right-o c4"></i>-->
                                </div>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>

            <!-- Modificadores -->
            <div v-if="preview.stats && preview.stats.modifiers.length > 0">
                <div class="">
                    <div class="flex align-center mb20">
                        <div class="f18 flex-fill">Modificadores</div>
                        <input-field inputClass="secondary"
                        v-model="searchModifiers"
                        placeholder="Buscar..."
                        pre="search"
                        cleareable
                        :icon="mobile ? 'search' : ''"
                        :timeout="200">
                        </input-field>
                    </div>
                    
                    <!--
                    <chart class="mb10"
                    :data="[preview.stats.modifiers]"
                    dataset="total_money"
                    type="pie"
                    :label="(data) => {return data.data}"
                    :singleDataset="false"
                    :maxDatasets="7"
                    :showLegend="true"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    :tooltip="(value, label, index) => {return label}"
                    height="200px">
                    </chart>
                    -->

                    <div class="section ofy" style="max-height: 500px">
                        <div :class="`entry mb10`"
                        v-for="(modifier, index) in preview.stats.modifiers"
                        :key="index"
                        v-show="Util.InString(modifier.data, searchModifiers)">
                            <div class="flex fill align-center">
                                <!-- <div class="percentage-icon" :style="{'background-color':Util.ChartColor(index, preview.stats.items.length)}">{{Percent(item.total_money,preview.stats.total_money)}}%</div>-->
                                <div class="flex column flex-fill">
                                    <span class="bold">{{modifier.data}}</span>
                                    <span class="secondary-text"><span class="bold">Cantidad: </span>{{Util.Number(modifier.count)}}</span>
                                    <!-- <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(item.transactions.length)}}</span>-->
                                </div>
                                <span class="bold mr10">{{Util.Price(modifier.total_money)}}</span>
                            </div>
                        </div>        
                    </div>
                </div>
            </div>
            <div v-if="preview.stats && !preview.stats.categories.length && !preview.stats.items.length" class="secondary-text ta-center mt10">No hay datos</div>
            </div>
        </div>

        <div slot="Pedidos Online" class="fill flex"
            :style="{
                'flex-direction': mobile ? 'column' : 'row',
                'height': '100%',
                'overflow': 'hidden'
            }">

            <div v-for="(preview, previewIndex) in ordersOnlinePreviews"
                :key="previewIndex"
                class="pa-body transactions-compare-panel"
                :style="comparingData ? {paddingTop: '0px !important'} : null"
                :class="{
                    'transactions-compare-panel--split-mobile': comparingData && mobile,
                    'transactions-compare-panel--divider-mobile': comparingData && previewIndex === 0 && mobile,
                    'transactions-compare-panel--divider-desktop': comparingData && previewIndex === 0 && !mobile
                }">

                <div v-if="comparingData" class="bold ta-center pa10 mb15 selectable transactions-range-sticky"
                    @click="OpenRangeInput(previewIndex, $event)">
                    {{ FormatRange(previewIndex === 0 ? rangeCompare : range) }}
                </div>

                <div v-if="preview && (preview.completed.count > 0 || preview.rejected.count > 0)" class="mb20">
                    <div class="f18 mb20">Total de pedidos</div>
                    <div class="section hdvm">
                        <chart
                        :data="preview.chartGeneral"
                        dataset="count"
                        type="pie"
                        :label="(order) => {return order.data}"
                        :singleDataset="false"
                        :maxDatasets="7"
                        :showLegend="false"
                        :xLabelFormat="null"
                        :yLabelFormat="null"
                        height="200px"
                        :tooltip="(value, label, index) => {return `${label} ${Percent(value, (preview.rejected.count + preview.completed.count) )}%`}">
                        </chart>

                        <div class="scroll-container">
                            <div :class="`entry ${isLocal?'selectable':''}`"
                            v-for="(order, index) in preview.general"
                            :key="index"
                            @click="isLocal ? $refs.iapTransactionsList.Open(order.transactions) : null">
                                <div class="flex align-center fill">
                                    <div class="percentage-icon cw" :style="{'background-color': Util.ChartColor(index, preview.general.length)}">{{Percent(order.count, (preview.rejected.count + preview.completed.count))}}%</div>
                                    <span class="bold">{{order.data}}</span>
                                    <div class="flex-fill"></div>
                                    <span class="bold">{{order.count}}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div v-if="preview && preview.rejected && preview.rejected.count > 0" class="mb20">
                    <div class="f18 mb20">Motivos de rechazo</div>
                    <div class="section hdvm">
                        <chart
                        :data="preview.chartRejectedReasons"
                        dataset="count"
                        type="pie"
                        :label="(reason) => {return Util.CancelledReason(reason.data)}"
                        :singleDataset="false"
                        :maxDatasets="7"
                        :showLegend="false"
                        :xLabelFormat="null"
                        :yLabelFormat="null"
                        height="200px"
                        :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.rejected.count)}%`}">
                        </chart>

                        <div class="scroll-container">
                            <div :class="`entry ${isLocal?'selectable':''}`"
                            v-for="(reason, index) in preview.rejected.rejected_reasons"
                            :key="index"
                            @click="isLocal ? $refs.iapTransactionsList.Open(reason.transactions) : null">
                                <div class="flex align-center fill">
                                    <div class="percentage-icon cw" :style="{'background-color': Util.ChartColor(index, preview.rejected.rejected_reasons.length)}">{{Percent(reason.count, preview.rejected.count)}}%</div>
                                    <span class="bold">{{Util.CancelledReason(reason.data)}}</span>
                                    <div class="flex-fill"></div>
                                    <span class="bold">{{reason.count}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="preview && preview.rejected && preview.rejected.count > 0" class="mb20">
                    <div class="f18 mb20">Items rechazados</div>
                    <div class="section hdvm">
                        <chart
                        :data="preview.chartRejectedItems"
                        dataset="count"
                        type="pie"
                        :label="(order) => {return order.data}"
                        :singleDataset="false"
                        :maxDatasets="7"
                        :showLegend="false"
                        :xLabelFormat="null"
                        :yLabelFormat="null"
                        height="200px"
                        :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.rejected.count_items )}%`}">
                        </chart>

                        <div class="scroll-container">
                            <div :class="`entry ${isLocal?'selectable':''}`"
                            style="height: auto;"
                            v-for="(item, index) in preview.rejected.items"
                            :key="index"
                            @click="isLocal ? $refs.iapTransactionsList.Open(item.transactions) : null">
                                <div class="flex align-center fill">
                                    <div class="percentage-icon cw" :style="{'background-color': Util.ChartColor(index, preview.rejected.items.length)}">{{Percent(item.count, preview.rejected.count_items)}}%</div>
                                    <span class="bold">{{item.data}}</span>
                                    <div class="flex-fill"></div>
                                    <span class="bold">{{item.count}}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div v-if="preview && preview.completed && preview.completed.count > 0" class="mb20">
                    <div class="f18 mb20">Items completados</div>
                    <div class="section hdvm">
                        <chart
                        :data="preview.chartCompletedItems"
                        dataset="count"
                        type="pie"
                        :label="(order) => {return order.data}"
                        :singleDataset="false"
                        :maxDatasets="7"
                        :showLegend="false"
                        :xLabelFormat="null"
                        :yLabelFormat="null"
                        height="200px"
                        :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.completed.count_items )}%`}">
                        </chart>

                        <div class="scroll-container">
                            <div :class="`entry ${isLocal?'selectable':''}`"
                            v-for="(item, index) in preview.completed.items"
                            :key="index"
                            @click="isLocal ? $refs.iapTransactionsList.Open(item.transactions) : null">
                            
                                <div class="flex align-center fill">
                                    <div class="percentage-icon cw" :style="{'background-color': Util.ChartColor(index, preview.completed.items.length)}">{{Percent(item.count, preview.completed.count_items)}}%</div>
                                    <span class="bold">{{item.data}}</span>
                                    <div class="flex-fill"></div>
                                    <span class="bold">{{item.count}}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div v-if="!preview || (preview.completed.count <= 0 && preview.rejected.count <= 0)" class="secondary-text ta-center mt10">No hay datos</div>
            </div>
        </div>

        <!-- Horarios --> 
        <div slot="Horarios" class="fill flex"
            :style="{
                'flex-direction': mobile ? 'column' : 'row',
                'height': '100%',
                'overflow': 'hidden'
            }">
            <div v-for="(preview, previewIndex) in previews"
                :key="previewIndex"
                class="pa-body transactions-compare-panel"
                :style="comparingData ? {paddingTop: '0px !important'} : null"
                :class="{
                    'transactions-compare-panel--split-mobile': comparingData && mobile,
                    'transactions-compare-panel--divider-mobile': comparingData && previewIndex === 0 && mobile,
                    'transactions-compare-panel--divider-desktop': comparingData && previewIndex === 0 && !mobile
                }"
                v-if="preview && preview.stats">

                <div v-if="comparingData" class="bold ta-center pa10 mb15 selectable transactions-range-sticky"
                    @click="OpenRangeInput(previewIndex, $event)">
                    {{ FormatRange(previewIndex === 0 ? rangeCompare : range) }}
                </div>

            <!-- Dias -->
            <div v-if="preview.stats && preview.stats.days.length > 0" class="mb20">
                
                <div class="f18 mb20">Días</div>

                <div class="section hdvm">

                    <chart
                    :data="preview.stats.chartDays"
                    dataset="total_money"
                    type="pie"
                    :label="(data) => {return days[data.data]}"
                    :singleDataset="false"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_money)}%`}"
                    height="200px"
                    :customColor="[null, null]"
                    :keyColors="Util.Chart.days">
                    </chart>

                    <div class="scroll-container">
                        <div :class="`entry ${isLocal?'selectable':''}`"
                        v-for="(day, index) in preview.stats.days"
                        :key="index"
                        @click="isLocal ? $refs.list.Open(day.transactions, null, {stats: true, days: false, label: days[day.data], total: day.total_money, color: Util.ChartColor(index, preview.stats.days.length, Util.Chart.days, day.data)}) : null">
                            <div class="flex align-center fill">
                                <div class="percentage-icon cw" :style="{'background-color':Util.ChartColor(index, preview.stats.days.length, Util.Chart.days, day.data)}">{{Percent(day.total_money, preview.stats.total_money)}}%</div>
                                <div class="flex column">
                                    <span class="bold">{{days[day.data]}}</span>
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(day.count)}}</span>
                                    <span class="secondary-text"><span class="bold">Promedio Venta: </span>{{Util.Price(Math.floor(day.total_money/day.transactions.length))}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(day.total_money)}}</span>
                                <!--<i v-if="isLocal" class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>

                </div>
              
            </div>
            
            <div v-if="preview.stats && preview.stats.hours.length > 0">
                
                <div class="f18 mb20">Horas</div>

                <div class="section hdvm">

                    <chart
                    :data="preview.stats.chartHours"
                    dataset="total_money"
                    type="pie"
                    :label="(data) => {return data.data + ' hrs'}"
                    :singleDataset="false"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_money)}%`}"
                    height="200px"
                    :customColor="[null, null]"
                    :keyColors="Util.Chart.hours">
                    </chart>

                    <div class="scroll-container">
                        <div :class="`entry ${isLocal?'selectable':''}`"
                        v-for="(hour, index) in preview.stats.hours"
                        :key="index"
                        @click="isLocal? $refs.list.Open(hour.transactions, null, {stats: true, hours: false, label: hour.data + ' hrs', total: hour.total_money, color: Util.ChartColor(index, preview.stats.hours.length, Util.Chart.hours, hour.data)}) : ''">
                            <div class="flex align-center fill">
                                <div class="percentage-icon cw" :style="{'background-color':Util.ChartColor(index, preview.stats.hours.length, Util.Chart.hours, hour.data)}">{{Percent(hour.total_money, preview.stats.total_money)}}%</div>
                                <div class="flex column">
                                    <span class="bold">{{hour.data}} hrs</span>
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(hour.count)}}</span>
                                    <span class="secondary-text"><span class="bold">Promedio Venta: </span>{{Util.Price(Math.floor(hour.total_money/hour.transactions.length))}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(hour.total_money)}}</span>
                                <!--<i v-if="isLocal" class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>

                </div>
  
            </div>
            <div v-if="preview.stats.hours.length == 0 && preview.stats.days.length == 0" class="secondary-text ta-center mt10">No hay datos</div>    
            </div>
        </div>

        
        <div slot="Venta" class="fill flex"
            :style="{
                'flex-direction': mobile ? 'column' : 'row',
                'height': '100%',
                'overflow': 'hidden'
            }">
            <div v-for="(preview, previewIndex) in previews"
                :key="previewIndex"
                class="pa-body transactions-compare-panel"
                :style="comparingData ? {paddingTop: '0px !important'} : null"
                :class="{
                    'transactions-compare-panel--split-mobile': comparingData && mobile,
                    'transactions-compare-panel--divider-mobile': comparingData && previewIndex === 0 && mobile,
                    'transactions-compare-panel--divider-desktop': comparingData && previewIndex === 0 && !mobile
                }"
                v-if="preview && preview.stats">

                <div v-if="comparingData" class="bold ta-center pa10 mb15 selectable transactions-range-sticky"
                    @click="OpenRangeInput(previewIndex, $event)">
                    {{ FormatRange(previewIndex === 0 ? rangeCompare : range) }}
                </div>

            <!--tipo de venta -->
            <div v-if="preview.stats.sale.length > 0" class="mb20">
                <div class="f18 mb20">Tipo de Venta</div>

                <div class="section hdvm">

                    <chart
                    :data="preview.stats.chartSale"
                    dataset="total_money"
                    type="pie"
                    :label="(data) => {return saleType[data.data]}"
                    :singleDataset="false"
                    :maxDatasets="7"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_money)}%`}"
                    height="200px"
                    :customColor="[null, null]"
                    :keyColors="Util.Chart.orderType">
                    </chart>

                    <div class="scroll-container">
                        <div :class="`entry ${isLocal?'selectable':''}`"
                        v-for="(sale, index) in preview.stats.sale"
                        :key="index"
                        @click="isLocal ? $refs.list.Open(sale.transactions, null, {stats: true, sale: false, label: saleType[sale.data], total: sale.total_money, color: Util.ChartColor(index, preview.stats.sale.length, Util.Chart.orderType, sale.data)}) : null">
                            <div class="flex align-center fill">
                                <div class="percentage-icon cw" :style="{'background-color':Util.ChartColor(index, preview.stats.sale.length, Util.Chart.orderType, sale.data)}">{{Percent(sale.total_money, preview.stats.total_money)}}%</div>
                                <div class="flex column">
                                    <span class="bold">{{saleType[sale.data]}}</span>
                                    <!-- <span class="secondary-text"><span class="bold">Total: </span>{{Util.Price(sale.total_money)}}</span> -->
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(sale.count)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(sale.total_money)}}</span>
                                <!--<i v-if="isLocal" class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>

                </div>
   
            </div>

            <div v-if="preview.stats.tables.length > 0" class="mb20">
                <div class="flex mb20 align-center" style="justify-content: space-between; ">
                    <div class="f18 ">Mesas</div>
                    <Button 
                        class="secondary" 
                        @click="OpenModalHistoryTransactions()"
                    >
                        Detalle de productos eliminados
                    </Button>
                </div>
                <div class="section">
                    <div class="hdvm">

                        <chart
                        :data="preview.stats.chartTables"
                        dataset="total_money"
                        type="pie"
                        :label="(data) => {return data.data}"
                        :singleDataset="false"
                        :maxDatasets="7"
                        :showLegend="false"
                        :xLabelFormat="null"
                        :yLabelFormat="null"
                        :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_money)}%`}"
                        height="200px">
                        </chart>

                        <div class="scroll-container">
                            <div :class="`entry ${isLocal?'selectable':''}`"
                            v-for="(table, index) in preview.stats.tables"
                            :key="index"
                            @click="isLocal ? $refs.list.Open(table.transactions, null, {stats: true, sale: false, label: table.data, total: table.total_money, color: Util.ChartColor(index, preview.stats.tables.length)}) : null">
                                <div class="flex align-center fill">
                                    <div class="percentage-icon cw" :style="{'background-color':Util.ChartColor(index, preview.stats.tables.length)}">{{Percent(table.total_money, preview.stats.total_tables)}}%</div>
                                    <div class="flex column">
                                        <span class="bold">{{table.data}}</span>
                                        <!-- <span class="secondary-text"><span class="bold">Total: </span>{{Util.Price(sale.total_money)}}</span> -->
                                        <span class="secondary-text" v-tooltip="'Promedio por comensal'"><span class="bold">Comensales: </span>{{Util.Number(table.customers)}} <span v-if="table.customers">({{Util.Price(table.total_money / table.customers)}})</span></span>
                                        <span class="secondary-text" v-tooltip="'Ticket promedio de la mesa'"><span class="bold">Transacciones: </span>{{Util.Number(table.transactions.length)}} <span v-if="table.transactions.length">({{Util.Price(table.total_money / table.transactions.length)}})</span></span>
                                    </div>
                                    <div class="flex-fill"></div>
                                    <span class="bold mr10">{{Util.Price(table.total_money)}}</span>
                                    <!--<i v-if="isLocal" class="icon icon-arrow-right-o c4"></i>-->
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="separator mb20 mt20"></div>

                    <div class="hdvm">
                        <div class="well flex align-center">
                            <avatar class="mr10"
                            icon="table"
                            :color="Util.baseColors.green">
                            </avatar>
                            <div class="flex-fill">
                                <div class="bold">Total</div>
                                <div class="secondary-text" v-if="preview.stats.table_transactions.length"><span class="bold">Ticket Promedio:</span> {{Util.Price(preview.stats.total_tables / preview.stats.table_transactions.length)}}</div>
                            </div>
                            <div class="ta-right">
                                <div class="f18">{{Util.Price(preview.stats.total_tables)}}</div>
                                <div class="secondary-text" v-if="preview.stats.table_transactions.length">{{Util.Number(preview.stats.table_transactions.length)}} transacciones</div>
                            </div>
                            
                        </div>

                        <div class="well flex align-center">
                            <avatar class="mr10"
                            icon="user"
                            :color="Util.baseColors.green">
                            </avatar>
                            <div class="flex-fill">
                                <div class="bold">Comensales</div>
                                <div class="secondary-text" v-if="preview.stats.total_customers_tables"><span class="bold">Promedio por comensal:</span> {{Util.Price(preview.stats.total_tables / preview.stats.total_customers_tables)}}</div>
                            </div>
                            <div class="f18">{{Util.Number(preview.stats.total_customers_tables)}}</div>
                        </div>

                    </div>

                </div>
   
            </div>

            <!-- Metodo de pago -->
            <div v-if="preview.stats.pay_methods.length > 0" class="mb20">
                <div class="f18 mb20">Métodos de Pago</div>

                <div class="section hdvm">

                    <chart
                    :data="preview.stats.chartPayMethods"
                    dataset="total_money"
                    type="pie"
                    :label="(data) => {return Util.PayMethod(data.data)}"
                    :singleDataset="false"
                    :maxDatasets="7"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_money)}%`}"
                    height="200px">
                    </chart>

                    <div class="scroll-container">
                        <div class="entry selectable"
                        v-for="(method, index) in preview.stats.pay_methods"
                        :key="index"
                        @click="$refs.list.Open(method.transactions, null, {stats: true, method: false, label: Util.PayMethod(method.data), total: method.total_money, color: Util.ChartColor(index, preview.stats.pay_methods.length)})">
                            <div class="flex align-center fill">
                                <div class="percentage-icon cw" :style="{'background-color':Util.ChartColor(index, preview.stats.pay_methods.length)}">{{Percent(method.total_money, preview.stats.total_money)}}%</div>
                                <div class="flex column">
                                    <span class="bold">{{Util.PayMethod(method.data)}}</span>
                                    <!-- <span class="secondary-text"><span class="bold">Total: </span>{{Util.Price(method.total_money)}}</span> -->
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(method.transactions.length)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(method.total_money)}}</span>
                                <!--<i class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <!-- medio de venta -->
            <div v-if="preview.stats.medium.length > 0">
                <div class="f18 mb20">Medio de Venta</div>

                <div class="section hdvm">

                    <chart
                    :data="preview.stats.chartMedium"
                    dataset="total_money"
                    type="pie"
                    :label="(data) => {return mediums[data.data]}"
                    :singleDataset="false"
                    :maxDatasets="7"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_money)}%`}"
                    height="200px"
                    :customColor="[null, null]"
                    :keyColors="Util.Chart.saleType">
                    </chart>

                    <div class="scroll-container">
                        <div :class="`entry ${isLocal?'selectable':''}`"
                        v-for="(medium, index) in preview.stats.medium"
                        :key="index"
                        @click="isLocal ? $refs.list.Open(medium.transactions, null, {stats: true, source: false, label: mediums[medium.data], total: medium.total_money, color: Util.ChartColor(index, preview.stats.medium.length, Util.Chart.saleType, medium.data)}) : null">
                            <div class="flex align-center fill">
                                <div class="percentage-icon cw" :style="{'background-color':Util.ChartColor(index, preview.stats.medium.length, Util.Chart.saleType, medium.data)}">{{Percent(medium.total_money, preview.stats.total_money)}}%</div>
                                <div class="flex column">
                                    <span class="bold">{{mediums[medium.data]}}</span>
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(medium.count)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(medium.total_money)}}</span>
                                <!--<i v-if="isLocal" class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>

                </div>
   
            </div>

            <div v-if="preview.stats.platforms && preview.stats.platforms.length > 0">
                <div class="f18 mb20 mt20">Plataformas</div>

                <div class="section hdvm">

                    <chart
                    :data="preview.stats.chartPlatforms"
                    dataset="total_money"
                    type="pie"
                    :label="(data) => {return Util.Platforms[data.data] || data.data}"
                    :singleDataset="false"
                    :maxDatasets="7"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_money)}%`}"
                    height="200px"
                    :customColor="[null, null]" 
                    :keyColors="Util.GetPlatformColor(preview.stats.platforms)">
                    </chart>

                    <div class="scroll-container">
                        <div :class="`entry ${isLocal?'selectable':''}`"
                        v-for="(platform, index) in preview.stats.platforms"
                        :key="index"
                        @click="isLocal ? $refs.list.Open(platform.transactions, null, {stats: true, source: false, label: Util.Platforms[platform.data] || platform.data, total: platform.total_money, color: Util.GetPlatformColor(platform.data)}) : null">
                            <div class="flex align-center fill">
                                <div class="percentage-icon cw" :style="{'background-color' :Util.GetPlatformColor(platform.data)}">{{Percent(platform.total_money, preview.stats.total_money)}}%</div>
                                <div class="flex column">
                                    <span class="bold">{{Util.Platforms[platform.data] || platform.data}}</span>
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(platform.count)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(platform.total_money)}}</span>
                            </div>
                        </div>
                    </div>

                </div>
   
            </div>

            <!-- Zona de reparto -->
            <div v-if="preview.stats.delivery_zones && preview.stats.delivery_zones.length > 0">
                <div class="f18 mb20 mt20">Zona de reparto</div>

                <div class="section hdvm">

                    <chart
                    :data="preview.stats.chartDeliveryZones"
                    dataset="total_money"
                    type="pie"
                    :label="(data) => {return data.data}"
                    :singleDataset="false"
                    :maxDatasets="7"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_money)}%`}"
                    height="200px"
                    :customColor="[null, null]"
                    :keyColors="Util.GetDeliveryZoneColor(preview.stats.delivery_zones)">

                    <!-- :keyColors="Util.GetPlatformColor(preview.stats.platforms)"  -->
                    </chart>

                    <div class="scroll-container">
                        <div :class="`entry ${isLocal?'selectable':''}`"
                        v-for="(zone, index) in preview.stats.delivery_zones"
                        :key="index"
                        @click="isLocal ? $refs.list.Open(zone.transactions, null, {stats: true, source: false, label: Util.Platforms[platform.data] || platform.data, total: zone.total_money, color: Util.GetDeliveryZoneColor(zone.data)}) : null">
                        <!-- @click="isLocal ? $refs.list.Open(zone.transactions, null, {stats: true, source: false, label: Util.Platforms[platform.data] || platform.data, total: zone.total_money, color: Util.GetPlatformColor(platform.data)}) : null"> -->
                            <div class="flex align-center fill">
                                <div class="percentage-icon cw" :style="{'background-color' : Util.GetDeliveryZoneColor(zone.data)}">{{Percent(zone.total_money, preview.stats.total_money)}}%</div>
                                <div class="flex column">
                                    <span class="bold">{{zone.data}}</span>
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(zone.count)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(zone.total_money)}}</span>
                            </div>
                        </div>
                    </div>

                </div>
   
            </div>

            <div v-if="preview.stats && !preview.stats.sale.length && !preview.stats.pay_methods.length" class="secondary-text ta-center mt10">No hay datos</div>    
            </div>
        </div>

         <!-- Ingresado Por -->
        <div slot="Personal" class="fill flex"
            :style="{
                'flex-direction': mobile ? 'column' : 'row',
                'height': '100%',
                'overflow': 'hidden'
            }">
            <div v-for="(preview, previewIndex) in previews"
                :key="previewIndex"
                class="pa-body transactions-compare-panel"
                :style="comparingData ? {paddingTop: '0px !important'} : null"
                :class="{
                    'transactions-compare-panel--split-mobile': comparingData && mobile,
                    'transactions-compare-panel--divider-mobile': comparingData && previewIndex === 0 && mobile,
                    'transactions-compare-panel--divider-desktop': comparingData && previewIndex === 0 && !mobile
                }"
                v-if="preview && preview.stats">

                <div v-if="comparingData" class="bold ta-center pa10 mb15 selectable transactions-range-sticky"
                    @click="OpenRangeInput(previewIndex, $event)">
                    {{ FormatRange(previewIndex === 0 ? rangeCompare : range) }}
                </div>
            
            <div v-if="preview.stats && preview.stats.creation.length > 0" class="mb20">
                
                <div class="f18 mb20">Ingresada por</div>

                <div class="section hdvm">

                    <chart class="mb10"
                    :data="preview.stats.chartCreation"
                    dataset="count"
                    type="pie"
                    :label="(data) => {return data.data}"
                    :singleDataset="false"
                    :maxDatasets="7"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    :tooltip="(value, label, index) => {return `${label} ${Math.round(100*value/preview.stats.completed.length)}%`}"
                    height="200px">
                    </chart>

                    <div class="scroll-container">
                        <div class="entry selectable"
                        v-for="(data, index) in preview.stats.creation"
                        :key="index"
                        @click="$refs.list.Open(data.transactions, null, {stats: true, label: data.data, total: data.total_money, color: Util.ChartColor(index, preview.stats.creation.length)})">
                            <div class="flex align-center fill">
                                <div class="percentage-icon cw" :style="{'background-color':Util.ChartColor(index, preview.stats.creation.length)}">{{Math.round(100*data.count/preview.stats.completed.length)}}%</div>
                                <div class="flex column">
                                    <span class="bold">{{data.data}}</span>
                                    <!--<span class="secondary-text"><span class="bold">Total: </span>{{Util.Price(data.total_money)}}</span>-->
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(data.count)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(data.total_money)}}</span>
                                <!--<i class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>

                </div>
            
            </div>

            <!-- Delivery -->
            <div v-if="preview.stats && preview.stats.delivery_methods.length" class="mb20">
                <div class="f18 mb20">Reparto</div>

                <div class="section mb10">
                    <div>
                        <div class="entry selectable"
                        v-for="(data, index) in preview.stats.delivery_staff"
                        :key="index+'staff'"
                        @click="$refs.list.Open(data.transactions)">
                            <div class="flex align-center fill">
                                <avatar class="mr10"
                                :label="data.data"
                                :color="Util.baseColors.blue">
                                </avatar>
                                <div class="flex column">
                                    <span class="bold">{{data.data}}</span>
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(data.count)}}</span>
                                    <span class="secondary-text" v-if="data.count" v-tooltip="'Tiempo entrega promedio'"><span class="bold">Entrega: </span>{{Util.SecondsToTime(data.time/data.count)}}</span>
                                    <span class="secondary-text" v-for="(method, keyMethod) in data.methods" :key="keyMethod" v-show="method.total_money"><span class="bold">{{Util.PayMethod(method.data)}}: </span>{{Util.Price(method.total_money)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(data.delivery)}}</span>
                                <!--<i class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>

                </div>

                <div class="section">
                    <!--<div class="f18 mb20">Método de Pago</div>-->

                    <div>
                        <div class="entry selectable"
                        v-for="(data, index) in preview.stats.delivery_methods"
                        :key="index+'methods'"
                        @click="$refs.list.Open(data.transactions)">
                            <div class="flex align-center fill">
                                <avatar class="mr10"
                                :imageIcon="data.data"
                                defaultImageIcon="59">
                                </avatar>
                                <div class="flex column">
                                    <span class="bold">Total {{Util.PayMethod(data.data)}}</span>
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(data.count)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(data.delivery)}}</span>
                                <!--<i class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>

            <!-- Delivery Externo -->
            <div v-if="preview.stats && preview.stats.delivery_external_methods.length" class="mb20">
                
                <div class="f18 mb20">Reparto Externo</div>

                <div class="section mb10">

                    <div>
                        <div class="entry selectable"
                        v-for="(data, index) in preview.stats.delivery_external_staff"
                        :key="index+'staff'"
                        @click="$refs.list.Open(data.transactions)">
                            <div class="flex align-center fill">
                                <avatar class="mr10"
                                :label="data.data"
                                :color="Util.baseColors.blue">
                                </avatar>
                                <div class="flex column">
                                    <span class="bold">{{data.data}}</span>
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(data.count)}}</span>
                                    <span class="secondary-text" v-for="(method, keyMethod) in data.methods" :key="keyMethod" v-show="method.total_money"><span class="bold">{{Util.PayMethod(method.data)}}: </span>{{Util.Price(method.total_money)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(data.delivery)}}</span>
                                <!--<i class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>

                </div>

                    <!--<div class="f18 mb20">Método de Pago</div>-->
                <div class="section">
                    <div>
                        <div class="entry selectable"
                        v-for="(data, index) in preview.stats.delivery_external_methods"
                        :key="index+'methods'"
                        @click="$refs.list.Open(data.transactions)">
                            <div class="flex align-center fill">
                                <avatar class="mr10"
                                :imageIcon="data.data"
                                defaultImageIcon="59">
                                </avatar>
                                <div class="flex column">
                                    <span class="bold">Total {{Util.PayMethod(data.data)}}</span>
                                    <!--<span class="secondary-text"><span class="bold">Total: </span>{{Util.Price(data.total_money)}}</span>-->
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(data.count)}}</span>
                                    <!-- <span class="secondary-text"><span class="bold">Monto transladado: </span>{{Util.Price(data.total_money)}}</span> -->
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(data.delivery)}}</span>
                                <!--<i class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>

                </div>
               
            </div>

            <!-- Propinas -->
            <div v-if="preview.stats && preview.stats.tips_methods.length > 0">
                <div class="f18 mb20">Propinas</div>
          
                <div class="section mb10">
        
                    <div>
                        <div class="entry selectable"
                        v-for="(data, index) in preview.stats.tips_staff"
                        :key="index+'tip_staff'"
                        @click="$refs.list.Open(data.transactions)">
                            <div class="flex align-center fill">
                                <avatar class="mr10"
                                :label="data.data"
                                color="AUTO">
                                </avatar>
                                <div class="flex column">
                                    <span class="bold">{{data.data}}</span>
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(data.transactions.length)}}</span>
                                    <span class="secondary-text" v-for="(method, keyMethod) in data.methods" :key="keyMethod"><span class="bold">{{Util.PayMethod(method.data)}}: </span>{{Util.Price(method.total_money)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(data.total_money)}}</span>
                                <!--<i class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>

                </div>

                    <!--<div class="f18 mb20">Método de Pago</div>-->
                
                <div class="section">
                    <div>
                        <div class="entry selectable"
                        v-for="(data, index) in preview.stats.tips_methods"
                        :key="index+'tip_method'"
                        @click="$refs.list.Open(data.transactions)">
                            <div class="flex align-center fill">
                                <avatar class="mr10"
                                :imageIcon="data.data"
                                defaultImageIcon="59">
                                </avatar>
                                <div class="flex column">
                                    <span class="bold">Total {{Util.PayMethod(data.data)}}</span>
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(data.transactions.length)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(data.total_money)}}</span>
                                <!--<i class="icon icon-arrow-right-o c4"></i>-->
                            </div>
                        </div>
                    </div>

                </div>
            
            </div>
            </div>
        </div>

        <!-- Clientes -->
        <div slot="Clientes" class="fill flex"
            :style="{
                'flex-direction': mobile ? 'column' : 'row',
                'height': '100%',
                'overflow': 'hidden'
            }">
            <div v-for="(preview, previewIndex) in previews"
                :key="previewIndex"
                class="pa-body transactions-compare-panel"
                :style="comparingData ? {paddingTop: '0px !important'} : null"
                :class="{
                    'transactions-compare-panel--split-mobile': comparingData && mobile,
                    'transactions-compare-panel--divider-mobile': comparingData && previewIndex === 0 && mobile,
                    'transactions-compare-panel--divider-desktop': comparingData && previewIndex === 0 && !mobile
                }"
                v-if="preview && preview.stats">

                <div v-if="comparingData" class="bold ta-center pa10 mb15 selectable transactions-range-sticky"
                    @click="OpenRangeInput(previewIndex, $event)">
                    {{ FormatRange(previewIndex === 0 ? rangeCompare : range) }}
                </div>

            <div v-if="preview.stats.clients.length > 0" class="mb20">

                <div class="flex align-center mb20">
                    <div class="f18 flex-fill">Clientes <div class="counter">{{preview.stats.clients.length}}</div></div>
                    <input-field inputClass="secondary"
                    v-model="searchCustomers"
                    placeholder="Buscar..."
                    pre="search"
                    cleareable
                    :icon="mobile ? 'search' : ''"
                    :timeout="200">
                    </input-field>
                </div>

                <div class="section hdvm">
                    <chart class="mb10"
                    :data="preview.stats.chartClients"
                    dataset="total_money"
                    type="pie"
                    :label="(data) => {return data.data}"
                    :singleDataset="false"
                    :maxDatasets="5"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    :tooltip="(value, label, index) => {return `${label} ${Math.round(100*value/preview.stats.total_clients)}%`}"
                    height="200px">
                    </chart>

                    <!-- <div class="scroll-container"> MIGUEL: CAMBIAR IMAGEN CON INICIALES POR PORCENTAJE CORRESPONDIENTE EN LA LISTA DE ABAJO
                        <div class="entry selectable"
                        v-for="(data, index) in stats.clients"
                        :key="index">
                            <div class="flex align-center fill">
                                <div class="percentage-icon cw" :style="{'background-color':Util.ChartColor(index, stats.clients.length)}">{{Math.round(100*data.total_money/stats.total_clients)}}%</div>
                                <div class="flex column">
                                    <span class="bold">{{data.data}}</span>
                                    <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(data.total_money)}}</span>
                                </div>
                                <div class="flex-fill"></div>
                                <span class="bold mr10">{{Util.Price(data.total_money)}}</span>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>

            <div v-if="preview.stats.clients.length > 0">
                <div>
                    <div :class="`section mb10 ${isLocal?'selectable':''}`"
                    v-for="(client, index) in preview.stats.clients"
                    :key="index"
                    v-show="Util.InString(client.data, searchCustomers)"
                    @click="isLocal ? $refs.list.Open(client.transactions, null, {stats: true, label: client.data, total: client.total_money, color: Util.ChartColor(index, preview.stats.clients.length)}) : ''">
                        <div class="flex align-center fill">
                            <div class="percentage-icon cw m10" :style="{'background-color': Util.ChartColor(index, preview.stats.clients.length)}">{{Math.round(100*client.total_money/preview.stats.total_clients)}}%</div>
                            <div class="flex column">
                                <span class="bold">{{client.data}} <i class="icon icon-star" style="color: rgb(0, 151, 255)" v-if="client.influye"></i></span>
                                <!--<span class="secondary-text"><span class="bold">Total: </span>{{Util.Price(client.total_money)}}</span>-->
                                <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(client.count)}}</span>
                                <span class="secondary-text"><span class="bold">Última Visita: </span>{{Util.Date(client.last_transaction, desktop ? 'LL' : 'DD/MM/YY')}}</span>
                                <!--<span class="secondary-text"><span class="bold">Primera Visita: </span>{{Util.Date(client.first_transaction,  desktop ? 'LL' : 'DD/MM/YY')}}</span>-->
                            </div>
                            <div class="flex-fill"></div>
                            <span class="bold mr10">{{Util.Price(client.total_money)}}</span>
                            <!--<i v-if="isLocal" class="icon icon-arrow-right-o c4"></i>-->
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="secondary-text ta-center mt10">No hay datos</div>    
            </div>
        </div>

        <div slot="Margen Bruto" class="fill flex"
            :style="{
                'flex-direction': mobile ? 'column' : 'row',
                'height': '100%',
                'overflow': 'hidden'
            }">
            <div v-for="(preview, previewIndex) in previews"
                :key="previewIndex"
                class="pa-body transactions-compare-panel"
                :style="comparingData ? {paddingTop: '0px !important'} : null"
                :class="{
                    'transactions-compare-panel--split-mobile': comparingData && mobile,
                    'transactions-compare-panel--divider-mobile': comparingData && previewIndex === 0 && mobile,
                    'transactions-compare-panel--divider-desktop': comparingData && previewIndex === 0 && !mobile
                }"
                v-if="preview && preview.stats">

                <div v-if="comparingData" class="bold ta-center pa10 mb15 selectable transactions-range-sticky"
                    @click="OpenRangeInput(previewIndex, $event)">
                    {{ FormatRange(previewIndex === 0 ? rangeCompare : range) }}
                </div>

            <div class="f18 mb20">Margen de Contribución</div>

            <div v-if="preview.stats.contribution_margin">

                <div class="hdvm mb10">
                    <div>
                        <div :class="`section flex align-center h100`">
                            <avatar class="mr10"
                            icon="invoice"
                            :color="Util.baseColors.yellow">
                            </avatar>
                            <div class="flex-fill">
                                <div class="bold">Ventas Brutas</div>
                                <div class="secondary-text">Con IVA</div>
                            </div>
                            <div class="f18">{{ Util.Price(preview.stats.total_money) }}</div>
                        </div>
                    </div>

                    <div>
                        <div :class="`section flex align-center h100`">
                            <avatar class="mr10"
                            icon="receipt"
                            :color="Util.baseColors.yellow">
                            </avatar>
                            <div class="flex-fill">
                                <div class="bold">Ventas Netas</div>
                                <div class="secondary-text">Sin IVA</div>
                            </div>
                            <div class="f18">{{ Util.Price(preview.stats.total_money /1.19) }}</div>
                        </div>
                    </div>
                </div>

                <div class="hdvm">
                    <div>
                        <div :class="`section flex align-center h100`">
                            <avatar class="mr10"
                            icon="money"
                            :color="Util.baseColors.red">
                            </avatar>
                            <div class="flex-fill">
                                <div class="bold">Costos Netos</div>
                                <div class="secondary-text">Sin IVA</div>
                            </div>
                            <div class="f18">{{ Util.Price(preview.stats.contribution_margin.net_costs) }}</div>
                        </div>
                    </div>

                    <div>
                        <div :class="`section flex align-center h100`">
                            <avatar class="mr10"
                            icon="bill"
                            :color="Util.baseColors.green">
                            </avatar>
                            <div class="flex-fill">
                                <div class="bold">Margen de Contribución</div>
                                <div class="secondary-text">{{ CalculateTotalContributionMargin(preview.stats) }}%</div>
                            </div>
                            <div class="f18">{{ Util.Price((preview.stats.total_money / 1.19) - preview.stats.contribution_margin.net_costs) }}</div>
                        </div>
                    </div>
                </div>

                <div class="f18 mb20 mt20">Detalle por ítem</div>

                <table class="summary">
                    <tr style="text-align: right">
                        <th>Item</th>
                        <th>Cantidad</th>
                        <th class="pr5">{{mobile ? 'Ventas B.' : 'Ventas brutas'}}</th>
                        <th class="pr5">{{mobile ? 'Ventas N.' : 'Ventas netas'}}</th>
                        <th class="pr5">{{mobile ? 'Costos N.' : 'Costos netos'}}</th>
                        <th class="pr5">{{mobile ? 'Costos N. (%)' : 'Costos netos (%)'}}</th>
                        <th class="pr5">{{mobile ? 'Margen' : 'Margen de contribución'}}</th>
                    </tr>

                    <tbody v-for="(item, index) in preview.stats.contribution_margin.item_history" :key="index">
                        <tr>
                            <td>{{item.item}}</td>
                            <td>{{`${Util.Number(item.quantity)}`}}</td>
                            <td>{{Util.Price(item.total_money || 0)}}</td>
                            <td>{{Util.Price(item.total_money / 1.19 || 0)}}</td>
                            <td>{{Util.Price(item.net_cost || 0)}}</td>
                            <td>
                                {{ item.total_money > 0
                                    ? Math.floor((item.net_cost * 1000) / (item.total_money / 1.19)) / 10
                                    : 0 }}%
                            </td>
                            <td>{{Util.Price(ContributionMargin(item))}} ({{ContributionMargin(item, true)}}%)</td>
                        </tr>
                        <template v-for="(modifier, modKey) in item.modifiers">
                            <tr
                            v-if="modKey !== 'ITSELF'"
                            :key="index + '-' + modKey"
                            class="secondary-text"
                            >
                                <td>&nbsp;&nbsp;&gt; {{ modifier.data }}</td>
                                <td>{{ Util.Number(modifier.count) }}</td>
                                <td>{{ item.combo? '-' : Util.Price(modifier.total_money || 0) }}</td>
                                <td>{{ item.combo? '-' : Util.Price(modifier.total_money / 1.19 || 0) }}</td>
                                <td>{{ item.combo? '-' : Util.Price(modifier.net_cost || 0) }}</td>
                                <td> {{ NetCost(modifier, item)}} </td>
                                <td>{{ item.combo? '-' : Util.Price(ContributionMargin(modifier)) }} <span v-if="!item.combo">({{ ContributionMargin(modifier, true) }}%)</span></td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div v-else class="secondary-text ta-center mt10">No hay datos</div>
            </div>
        </div>
        <!-- sublocales -->
        <div slot="Locales" class="fill flex"
            :style="{
                'flex-direction': mobile ? 'column' : 'row',
                'height': '100%',
                'overflow': 'hidden'
            }">
            <div v-for="(preview, previewIndex) in previews"
                :key="previewIndex"
                class="pa-body transactions-compare-panel"
                :style="comparingData ? {paddingTop: '0px !important'} : null"
                :class="{
                    'transactions-compare-panel--split-mobile': comparingData && mobile,
                    'transactions-compare-panel--divider-mobile': comparingData && previewIndex === 0 && mobile,
                    'transactions-compare-panel--divider-desktop': comparingData && previewIndex === 0 && !mobile
                }"
                v-if="preview && preview.stats">

                <div v-if="comparingData" class="bold ta-center pa10 mb15 selectable transactions-range-sticky"
                    @click="OpenRangeInput(previewIndex, $event)">
                    {{ FormatRange(previewIndex === 0 ? rangeCompare : range) }}
                </div>

            <div v-if="preview.stats.locals && preview.stats.locals.length" class="section">
                <chart class="mb10"
                :data="preview.stats.chartLocals"
                dataset="total_money"
                type="pie"
                :label="(data) => {return data.data}"
                :singleDataset="false"
                :maxDatasets="7"
                :showLegend="true"
                :xLabelFormat="null"
                :yLabelFormat="null"
                :tooltip="(value, label, index) => {return `${label} ${Percent(value, preview.stats.total_money)}%`}"
                height="200px">
                </chart>

                <div class="well mb5"
                v-for="(local, index) in preview.stats.locals"
                :key="index">
                    <div class="flex align-center fill">
                        <div class="percentage-icon cw" :style="{'background-color':Util.ChartColor(index, preview.stats.locals.length)}">{{Percent(local.total_money, preview.stats.total_money)}}%</div>
                        <div class="flex column">
                            <span class="bold">{{local.data}}</span>
                            <span class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(local.count)}}</span>
                        </div>
                        <div class="flex-fill"></div>
                        <span class="bold mr10">{{Util.Price(local.total_money)}}</span>
                    </div>
                </div>
            </div>
            <div v-else class="secondary-text ta-center mt10">No hay datos</div>
            </div>
        </div>

    </tabs>

<!--Modal Transaction Search -->
<modal v-model="modalTransactionSearch" dir="center" modalClass="sm" title="Buscar Transacción">
    <div class="section">
        <input-field
        v-model="transactionNumber"
        label="Número Ticket"
        type="int+"
        prefix="# "
        @OnEnter="SearchTransaction(0)">
        </input-field>
    </div>
    
    <button slot="actions" class="primary purple" @click="SearchTransaction(0)">Buscar</button>
    
</modal>

<modal v-model="modalDetails" dir="right" :modalClass="['fill borderless', 'md right h100']" :title="modalDetails && modalDetails.title? modalDetails.title : 'Detalles'" hideActions>
    <i slot="pre" v-tooltip="'Atrás'" v-if="modalDetails && modalDetails.back" class="options icon-arrow-left mr5" @click="modalDetails=itemDetails"></i>
    <i slot="pre" v-tooltip="'Atrás'" v-if="modalDetails && modalDetails.back_group" class="options icon-arrow-left mr5" @click="modalDetails=groupModifiersDetails"></i>
    <div v-if="modalDetails && modalDetails.items.length == 0">
        <div class="secondary-text ta-center mt10">No hay datos</div>
    </div>
    <div v-else>
        <div  v-if="modalDetails" class="pa20">
            <div>
                <chart
                    v-if="modalDetails.total_items != 0"
                    :data="modalDetails.chart"
                    dataset="total_money"
                    type="pie"
                    class="mb20"
                    :label="(data) => {return data.data}"
                    :singleDataset="false"
                    :maxDatasets="7"
                    :showLegend="false"
                    :xLabelFormat="null"
                    :yLabelFormat="null"
                    height="200px"
                    :tooltip="(value, label, index) => {return `${label} ${Percent(value, modalDetails.total_items)}%`}">
                </chart>
                <div :class="`entry ${modalDetails && modalDetails.level!= 2?'selectable':''}`" v-for="(item, index) in modalDetails.items" 
                    :key="index"
                    @click="modalDetails? selectedLevelDetails(modalDetails.level, modalDetails.items, item.data) : null">
                    <div class="flex align-center fill">
                        <div class="percentage-icon cw" :style="{'background-color': Util.ChartColor(index, modalDetails.items.length)}">{{modalDetails.total_items == 0? 0 : Percent(item.total_money, modalDetails.total_items)}}%</div>
                        <span class="bold">{{item.data}}</span>
                        <div class="flex-fill"></div>
                        <span class="bold">{{Util.Price(item.total_money)}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</modal>

<modal v-model="modalTransactionsCanceled" dir="right" :modalClass="['fill borderless', 'lg right h100']" :title="'Detalles de transacciones canceladas'">
    
    <div class="pa20" v-if="modalTransactionsCanceled && modalTransactionsCanceled.count > 0">
        
        <div class="mb20">
            <div class="f18 mb10">Motivos de rechazo</div>
            <div class="hdvm">
                <chart
                :data="modalTransactionsCanceled.chartReasons"
                dataset="count"
                type="pie"
                :label="(reason) => {return Util.CancelledReason(reason.data)}"
                :singleDataset="false"
                :maxDatasets="7"
                :showLegend="false"
                :xLabelFormat="null"
                :yLabelFormat="null"
                height="200px"
                :tooltip="(value, label, index) => {return `${label} ${Percent(value, modalTransactionsCanceled.count)}%`}">
                </chart>

                <div class="scroll-container">
                    <div :class="`entry ${isLocal?'selectable':''}`"
                    v-for="(reason, index) in modalTransactionsCanceled.rejected_reasons"
                    :key="index"
                    @click="$refs.list.Open(reason.transactions)">
                        <div class="flex align-center fill">
                            <div class="percentage-icon cw" :style="{'background-color': Util.ChartColor(index, modalTransactionsCanceled.rejected_reasons.length)}">{{Percent(reason.count, modalTransactionsCanceled.count)}}%</div>
                            <span class="bold">{{Util.CancelledReason(reason.data)}}</span>
                            <div class="flex-fill"></div>
                            <span class="bold">{{reason.count}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb20">
            <div class="f18 mb10">Ítems cancelados</div>
            <div class="hdvm">
                <chart
                :data="modalTransactionsCanceled.chartItems"
                dataset="count"
                type="pie"
                :label="(item) => {return item.data}"
                :singleDataset="false"
                :maxDatasets="7"
                :showLegend="false"
                :xLabelFormat="null"
                :yLabelFormat="null"
                height="200px"
                :tooltip="(value, label, index) => {return `${label} ${Percent(value, modalTransactionsCanceled.count_items)}%`}">
                </chart>

                <div class="scroll-container">
                    <div :class="`entry ${isLocal?'selectable':''}`"
                    v-for="(item, index) in modalTransactionsCanceled.items"
                    :key="index"
                    @click="$refs.list.Open(item.transactions)">
                        <div class="flex align-center fill">
                            <div class="percentage-icon cw" :style="{'background-color': Util.ChartColor(index, modalTransactionsCanceled.items.length)}">{{Percent(item.count, modalTransactionsCanceled.count_items)}}%</div>
                            <span class="bold">{{item.data}}</span>
                            <div class="flex-fill"></div>
                            <span class="bold">{{item.count}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="f18 mb10">Personas que cancelaron</div>
            <div class="hdvm">
                <chart
                :data="modalTransactionsCanceled.chartPeople"
                dataset="count"
                type="pie"
                :label="(person) => {return person.data}"
                :singleDataset="false"
                :maxDatasets="7"
                :showLegend="false"
                :xLabelFormat="null"
                :yLabelFormat="null"
                height="200px"
                :tooltip="(value, label, index) => {return `${label} ${Percent(value, modalTransactionsCanceled.count)}%`}">
                </chart>

                <div class="scroll-container">
                    <div :class="`entry ${isLocal?'selectable':''}`"
                    v-for="(person, index) in modalTransactionsCanceled.people"
                    :key="index"
                    @click="$refs.list.Open(person.transactions)">
                        <div class="flex align-center fill">
                            <div class="percentage-icon cw" :style="{'background-color': Util.ChartColor(index, modalTransactionsCanceled.people.length)}">{{Percent(person.count, modalTransactionsCanceled.count)}}%</div>
                            <span class="bold">{{person.data}}</span>
                            <div class="flex-fill"></div>
                            <span class="bold">{{person.count}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button slot="actions" class="secondary" @click="$refs.list.Open(stats.cancelled)">Ver todas las transacciones</button>
</modal>

<modal v-model="modalHistoryTransactions" dir="right" :modalClass="['fill borderless', 'xl right h100']" :title="'Detalle de productos eliminados'" hideActions>
    <div class="pa20 pt0" v-if="modalHistoryTransactions">

        <div class="sticky bgbg1">
            <div class="flex" :style="{ 'justify-content': mobile ? 'flex-end' : '' }" style="padding: 20px 0px 15px 0px;" >

                <input-select
                    v-model="modalHistoryTransactions.selectedItemName"
                    class="mr5 "
                    style="max-width: 219px;"
                    :items="[{text: 'Producto', value: ''}, ...modalHistoryTransactions.itemsNamesOptions]"
                    @OnValueChanged="handleFilterChange()"
                    :icon="mobile ? 'menu' : ''">
                </input-select>

                <input-select
                    v-model="modalHistoryTransactions.selectedCreatedBy"
                    class="mr5"
                    :items="[{text: 'Cuenta', value: ''}, ...modalHistoryTransactions.createdBy]"
                    @OnValueChanged="handleFilterChange()"
                    :icon="mobile ? 'user' : ''">
                </input-select>

                <input-select
                    v-model="modalHistoryTransactions.selectedTable"
                    class="mr5"
                    :items="[{text: 'Mesa', value: ''}, ...modalHistoryTransactions.tablesOptions]"
                    @OnValueChanged="handleFilterChange()"
                    :icon="mobile ? 'table' : ''">
                </input-select>

                <input-range 
                    class="mr5"
                    v-model="modalHistoryTransactions.selectedDateRange"
                    :icon="mobile ? 'calendar' : ''"
                    @OnValueChanged="handleFilterChange()">
                </input-range>
           
            </div>
        </div>

        <div v-if="modalHistoryTransactions.visibleItems.length > 0">
            <table class="summary">
                <tr style="position: sticky; top: 70px; z-index: 1;" class="bgbg1 pt10"> 
                    <th >Producto</th>
                    <th >Mesa</th>
                    <th >Cuenta</th>
                    <th >Fecha</th>
                </tr>
                <tr 
                v-for="(item, index) in modalHistoryTransactions.visibleItems" 
                    :key="index" 
                    @click="OpenModalTransactionDetails(item.id_transaction)"
                    class="selectable"
                >
                    <td class="pr5">{{ item.count ? '(' + item.count + ')' : '' }} {{item.item_name}}</td>
                    <td class="pr5">{{item.table}}</td>
                    <td class="pr5">{{item.create_by}}</td>
                    <td class="pr5">{{Util.Date(item.edit_at,"DD/MM/YYYY HH:mm")}}</td>
                </tr>
            </table>
        </div>
        <div v-else>
            <div class="secondary-text ta-center mt10">No hay datos</div>
        </div>
    </div>
</modal>


<transaction-details ref="transactionDetails" @OnTransactionDeleted="OnTransactionDeleted"></transaction-details>

<transactions-list ref="list" @OnTransactionDeleted="OnTransactionDeleted" @OnTransactionEdit="OnTransactionEdit" @OnTransactionCanceled="OnTransactionDeleted"></transactions-list>

<iap-transactions-list ref="iapTransactionsList"></iap-transactions-list>

</div>
</template>

<script>
var moment = require('moment');
moment.locale('es');
export default {
    props: {
        showDetails: {
            type: Boolean,
            default: true
        },
        limitRange: {
            type: Boolean,
            default: false
        },
        ticket_id: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            data: [],
            dataGroup: null,
            colors: Util.colors,
            stats: null,
            statsCompare: null,
            range: {
                option: 'MONTH',
                index: 0
            },
            rangeCompare: {
                option: 'MONTH',
                index: 0
            },
            comparingData: false,
            status: null,
            transactionNumber: 0,
            transaction: null,
            filter: null,
            currentPage: 0,
            collection: {
				heightType: 'automatic',
				itemHeight: 50,
            },
            currentTransactions: [],
            //variables para cargar datos on demand
            currentTab: null,
            maxDataPerTab: 10,
            currentDataPerTab: 10,
            dataStep: 10,
            loadingMoreData: false,
            modalTransactionSearch: false,
            saleType: {
                TAKEAWAY: 'Llevar',
                SERVE: 'Servir',
                DELIVERY: 'Delivery'
            },
            days: {
                0: 'Domingo',
                1: 'Lunes',
                2: 'Martes',
                3: 'Miércoles',
                4: 'Jueves',
                5: 'Viernes',
                6: 'Sábado'
            },
            sublocals: [],
            idLocal: null,
            mediums: {
                INFLUYE_ADMIN: 'Punto de Venta',
                INFLUYE_APP: 'Influye App',
                INFLUYE_WEB: 'Ecommerce',
                INFLUYE_TOTEM: 'Tótem',
                PEDIDOSYA_APP: 'PedidosYa App',
                UBER_EATS: 'Uber Eats'
            },
            tabs: null,
            items: null,
            itemsCompare: null,
            modalDetails: null,
            itemDetails: null,
            groupModifiersDetails: null,
            ordersOnline: null,
            ordersOnlineCompare: null,
            RangeOrdersOnlineKey: null,
            RangeOrdersOnlineCompareKey: null,
            modalTransactionsCanceled: null,
            modalHistoryTransactions: null,
            searchModifiers: '',
            searchItems: '',
            searchSections: '',
            searchCustomers: ''
        }
    },
    mounted() {

        this.tabs = [];
        this.tabs.push('General');
        if(this.Local.modules.module_transaction_stats) this.tabs.push('Menu');
        if(this.Local.modules.module_store) this.tabs.push('Pedidos Online');
        if(this.Local.modules.module_transaction_stats) this.tabs.push('Horarios');
        if(this.Local.modules.module_transaction_stats) this.tabs.push('Venta');
        if(this.Local.modules.module_transaction_stats) this.tabs.push('Clientes');
        if(this.Local.modules.module_transaction_stats && this.Local.type == 'LOCAL') this.tabs.push('Personal');
        if(this.Local.modules.module_margin) this.tabs.push('Margen Bruto');
        if(this.Local.type == 'FRANCHISE') this.tabs.push('Locales');

        this.idLocal = this.Local.id;
        /*
        this.$nextTick(() => {
            var moment = require('moment');
            this.range = {
                option: 'DAY',
                index: 0,
                label: 'Hoy',
                rangeStart: moment().startOf('day').unix(),
                rangeEnd: moment().unix(),
            };
            this.Search();

            if(this.Local.type == 'FRANCHISE')
            {
                axios.get(`/sublocals/${this.Local.id}`).then(res => {
                    console.log(res.data);
                    var sublocals = [{text: this.Local.name, value: this.Local.id}];
                    res.data.sublocals.forEach(sublocal => {
                        sublocals.push({text: sublocal.name, value: sublocal.id});
                    });
                    res.data.attached.forEach(sublocal => {
                        sublocals.push({text: sublocal.name, value: sublocal.id});
                    });
                    this.sublocals = sublocals;
                }).catch(err => {
                    console.log(err);
                });
            }

        });
        */
    },
    methods: {
        FormatRange(r) {
            if (!r) return '';
            const trimmed = r.label != null ? String(r.label).trim() : '';
            if (trimmed) return trimmed;
            if (r.rangeStart != null && r.rangeEnd != null) {
                return `${this.Util.Date(r.rangeStart, 'DD/MM/YYYY')} - ${this.Util.Date(r.rangeEnd, 'DD/MM/YYYY')}`;
            }
            return '';
        },
        OpenRangeInput(previewIndex, event) {
            let target = previewIndex === 0
                ? this.$refs.rangeCompareInput
                : this.$refs.rangeInput;
            const anchor = event && event.currentTarget;
            if (target) {
                target.Open(anchor);
            }
        },
        PreviousYear(baseRange) {
            const start = (baseRange && baseRange.rangeStart ? moment.unix(baseRange.rangeStart) : moment().startOf('month')).clone().subtract(1, 'year');
            const end   = (baseRange && baseRange.rangeEnd   ? moment.unix(baseRange.rangeEnd)   : moment().endOf('month')  ).clone().subtract(1, 'year');
            const option = (baseRange && baseRange.option) || 'RANGE';
            let label;
            
            if (baseRange && baseRange.label && /20\d{2}/.test(baseRange.label)) {
                label = baseRange.label.replace(/20\d{2}/g, (m) => String(parseInt(m) - 1));
            } else if (option === 'MONTH') {
                label = start.format('MMMM YYYY');
            } else if (option === 'YEAR') {
                label = start.format('YYYY');
            } else if (option === 'DAY') {
                label = start.format('ddd D MMMM YYYY');
            } else {
                label = `${this.Util.Date(start.unix(), 'DD/MM/YYYY')} - ${this.Util.Date(end.unix(), 'DD/MM/YYYY')}`;
            }
            return {
                option,
                label,
                rangeStart: start.unix(),
                rangeEnd: end.unix(),
            };
        },
        Search(range) {
            this.$root.$emit('Loading');

            if(this.currentTab == 'Pedidos Online'){
                this.SearchOnline(range);
            }
            
            this.searchCustomers = '';
            this.searchItems = '';
            this.searchSections = '';
            this.searchModifiers = '';

            axios.post(`/transactions/${this.idLocal}/stats`, range).then(res => {                
                this.formatSearchData(res);

                this.stats = res.data;
                this.items = res.data.items;

                this.$root.$emit('Response', res);
            }).catch(err => {
                this.$root.$emit('Response', err);
            });
        },
        SearchCompare(range) {
            this.$root.$emit('Loading');

            if(this.currentTab == 'Pedidos Online'){
                this.SearchOnline(range);
            }
            
            this.searchCustomers = '';
            this.searchItems = '';
            this.searchSections = '';
            this.searchModifiers = '';

            axios.post(`/transactions/${this.idLocal}/stats`, range).then(res => {                
                this.formatSearchData(res);

                this.statsCompare = res.data;
                this.itemsCompare = res.data.items;

                this.$root.$emit('Response', res);
            }).catch(err => {
                this.$root.$emit('Response', err);
            });
        },
        formatSearchData(res) {
            var total_categories = 0;
            for(var i = 0; i < res.data.categories.length; i++)
                total_categories += res.data.categories[i].count;
            res.data.total_categories = total_categories;

            var total_sections = 0;
            for(var i = 0; i < res.data.sections.length; i++)
                total_sections += res.data.sections[i].total_money;
            res.data.total_sections = total_sections;

            //generar lista de modificadores
            var modifiers = [];
            for(var i = 0; i < res.data.items.length; i++)
            {
                var item = res.data.items[i];
                for(var key in item.modifiers)
                {
                    var modifier = item.modifiers[key];
                    if(modifier.data !== 'Sin Modificadores')
                    {
                        modifiers.push({
                            data: `${item.data} - ${modifier.data}`,
                            count: modifier.count,
                            total_money: modifier.total_money
                        });
                    }
                };
            };
            modifiers.sort((a, b) => {
                return b.total_money - a.total_money;
            });
            res.data.modifiers = modifiers;

            let totalClients = 0;
            for(let i = 0; i < res.data.clients.length; i++)
                totalClients += res.data.clients[i].total_money;
            res.data.total_clients = totalClients;

            res.data.chartHistory = [res.data.history];
            res.data.chartCategories = [res.data.categories];
            res.data.chartSections = [res.data.sections];
            res.data.chartItems = [res.data.items];
            res.data.chartDays = [res.data.days];
            res.data.chartHours = [res.data.hours];
            res.data.chartSale = [res.data.sale];
            res.data.chartPayMethods = [res.data.pay_methods];
            res.data.chartMedium = [res.data.medium];
            res.data.chartPlatforms = [res.data.platforms];
            res.data.chartCreation = [res.data.creation];
            res.data.chartClients = [res.data.clients];
            res.data.chartLocals = [res.data.locals];
            res.data.chartTables = [res.data.tables];
            res.data.chartDeliveryZones = [res.data.delivery_zones];

            let arrTablesTransactions = [];
            res.data.tables.forEach(table => {
                arrTablesTransactions = arrTablesTransactions.concat(table.transactions);
            });
            arrTablesTransactions.sort((a, b) => {return b - a});
            res.data.table_transactions = arrTablesTransactions;
        },
        SearchTransaction(value)
        {
            if(value) this.transactionNumber = parseInt(this.transactionNumber) + value;

            this.$root.$emit('Loading');
            axios.get(`/local/${this.Local.id}/transaction/${this.transactionNumber}`).then(res => {
                if(!res.data.error)
                    this.$refs.transactionDetails.Open(res.data.transaction);
                this.$root.$emit('Response', res);
            }).catch(err => {
                this.$root.$emit('Response', err);
            });
        },
        DeleteTransaction()
        {
            if(!this.transaction) return;
            this.$root.$emit('Loading');
            axios.delete(`/rest/transaction/${this.transaction.transaction.id}`).then(res => {
                this.$root.$emit('Response', res);
                this.transaction = null;
            }).catch(err => {
                this.$root.$emit('Response', err);
            });
        },
        LoadMoreTabData(tab) {
            if(!this.loadingMoreData)
            {
                this.loadingMoreData = true;
                this.currentDataPerTab += this.dataStep;
                setTimeout(() => {
                    this.loadingMoreData = false;
                }, 100);
            }
        },
        Export() 
        {
            this.Loading();
            //bypass cloudflare
            var Axios = require('axios');
            let axiosConn = Axios.create({
                baseURL: this.Util.connectionAddresses.backend.replace('backend', 'stream')+'admin/',
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.token)}`
                }
            });
            axiosConn.post(`/transactions/${this.Local.id}/export?v2=true`, this.range, {responseType: 'blob'}).then(res => {
                this.Response(res);
                this.Util.DownloadFile(res, `transacciones_${this.Util.Date(this.range.rangeStart, 'DD-MM-YYYY')}_${this.Util.Date(this.range.rangeEnd, 'DD-MM-YYYY')}.xlsx`);
            }).catch(err => {
                this.Response(err);
            });
        },
        Percent(amount, total) 
        {
            if(total <= 0) return '';
            return Math.round(100*amount/total);
        },
        LocalChanged(id)
        {
            console.log(id);
            this.idLocal = id;
            this.Search();
        },
        openModalDetails(section, total_section){
            let records = [];

            for(let i in this.items){
                if(this.items[i].section === section){
                    records.push(this.items[i]);
                }
            }
            this.modalDetails = {};
            this.modalDetails.title = 'Detalle de '+section;
            this.modalDetails.items = records;
            this.modalDetails.chart = [records];
            this.modalDetails.total_items = total_section;
            this.modalDetails.level = 0;

            this.itemDetails = this.modalDetails;
        },
        openModalModifierGroupDetails(item){
            let groups = [];
            let totalItem = 0;

            for(let indexItems in this.items){
                for(let indexItem in this.items[indexItems].modifiers){
                    let itemsModifiers = this.items[indexItems].modifiers;

                    if(itemsModifiers[indexItem].item == item){
                        let response = groups.find(group => group.data == itemsModifiers[indexItem].group);
                        if (!response) {
                            let newGroup = {
                                data: itemsModifiers[indexItem].group,
                                total_money: itemsModifiers[indexItem].total_money,
                                modifier: [
                                    [
                                        itemsModifiers[indexItem].data,
                                        itemsModifiers[indexItem].total_money
                                    ]
                                ]
                            };
                            
                            groups.push(newGroup);
                        }else{
                            response.total_money += itemsModifiers[indexItem].total_money;
                            response.modifier.push([itemsModifiers[indexItem].data, itemsModifiers[indexItem].total_money]);
                        }

                        totalItem += itemsModifiers[indexItem].total_money;
                    }
                }
            }

            groups.sort(function (a, b) {
                return b.total_money - a.total_money;
            });

            this.modalDetails = {};
            this.modalDetails.title = 'Detalle de '+item;
            this.modalDetails.items = groups;
            this.modalDetails.chart = [groups];
            this.modalDetails.total_items = totalItem;
            this.modalDetails.item = item;
            this.modalDetails.back = true;
            this.modalDetails.level = 1;
            
            this.groupModifiersDetails = this.modalDetails;
        },
        openModalModifierDetails(modifiersGroup, dataModifier){
            let modifiers = [];
            let total_modifier = 0;

            modifiersGroup.forEach(modifierGroup => {
                if (modifierGroup.data === dataModifier) {
                    modifierGroup.modifier.forEach( modifier => {
                        modifiers.push({
                            data: modifier[0],
                            total_money: modifier[1]
                        });
                        total_modifier += modifier[1];
                    })
                }
            });

            this.modalDetails = {};
            this.modalDetails.title = 'Detalle de '+dataModifier;
            this.modalDetails.items = modifiers;
            this.modalDetails.chart = [modifiers];
            this.modalDetails.total_items = total_modifier;
            this.modalDetails.back_group = true;
            this.modalDetails.level = 2;

        },
        selectedLevelDetails(level, modalIteml, item){
            switch (level) {
                case 0:
                    return this.openModalModifierGroupDetails(item);
                case 1:
                    return this.openModalModifierDetails(modalIteml, item);
                default:
                    break;
            }
        },
        rangeKey(range) {
            if (!range) return '';
            const option = range.option || '';
            const index = (range.index !== undefined && range.index !== null) ? range.index : '';
            const start = (range.rangeStart !== undefined && range.rangeStart !== null) ? range.rangeStart : '';
            const end = (range.rangeEnd !== undefined && range.rangeEnd !== null) ? range.rangeEnd : '';

            return `${option}:${index}:${start}:${end}`;
        },
        SearchOnline(range){
            const key = this.rangeKey(range);
            const isCompareRange = !!(this.comparingData && this.rangeCompare && key === this.rangeKey(this.rangeCompare));
            const currentKey = isCompareRange ? this.RangeOrdersOnlineCompareKey : this.RangeOrdersOnlineKey;
            if(currentKey === key) return;

            this.Loading();

            axios.post(`/transactions/online/${this.idLocal}/stats`, range).then( ({data}) => {
                data.general = Object.values(data);
                data.general.sort((a, b) => {return b.count - a.count});

                data.chartGeneral = [data.general];
                data.chartRejectedReasons = [Object.values(data.rejected.rejected_reasons)];
                data.chartRejectedItems = [Object.values(data.rejected.items)];
                data.chartCompletedItems = [Object.values(data.completed.items)];

                if(isCompareRange) {
                    this.ordersOnlineCompare = data;
                    this.RangeOrdersOnlineCompareKey = key;
                } else {
                    this.ordersOnline = data;
                    this.RangeOrdersOnlineKey = key;
                }
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        detailsTransactionsCanceled(transactionsCanceled){
            if(transactionsCanceled.length == 0) return;

            this.Loading();

            axios.post(`/transactions/canceled/${this.Local.id}`, {
                ids: transactionsCanceled
            }).then( ({data}) => {
                data.chartReasons = [Object.values(data.rejected_reasons)];
                data.chartItems = [Object.values(data.items)];
                data.chartPeople = [Object.values(data.people)];
                this.modalTransactionsCanceled =  data;
                this.Response(this.modalTransactionsCanceled);
            }).catch(err => {
                this.Response(err);
            });
        },
        OnTransactionDeleted(id)
        {
            this.Search(this.range);
        },
        OnTransactionEdit()
        {
            this.Search(this.range);
        },
        ContributionMargin(item, percent = false){
            if (!item) return 0;

            const total = Number(item.total_money) || 0;
            const cost = Number(item.net_cost) || 0;

            const netSales = total / 1.19;

            const contributionMargin = netSales - cost;

            if (!percent) return contributionMargin;

            if (netSales === 0) {
                if (cost > 0) return -100;
                return 0;
            }

            const contributionMarginPercent = (contributionMargin / netSales) * 100;

            return Math.floor(contributionMarginPercent * 10) / 10;
        },
        NetCost(modifier, item){
            if (!modifier || !item) return '0%';

            if (item.combo) return '-';

            const cost = Number(modifier.net_cost) || 0;
            const netSales = modifier.total_money ? Number(modifier.total_money) / 1.19 : 0;

            if (netSales <= 0) return '0%';

            const percent = (cost / netSales) * 100;

            const rounded = Math.floor(percent * 10) / 10;

            return `${rounded}%`;
        },
        handleFilterChange()
        {
            const { selectedItemName, selectedTable, selectedCreatedBy, selectedDateRange, allItems } = this.modalHistoryTransactions

            this.modalHistoryTransactions.visibleItems = allItems.filter(item => {
                const matchName = !selectedItemName || item.item_name.includes(selectedItemName)
                const matchTable = !selectedTable || item.table === selectedTable
                const matchCreatedBy = !selectedCreatedBy || item.create_by === selectedCreatedBy

                const matchDate = !selectedDateRange ||
                (
                    item.edit_at &&
                    item.edit_at >= selectedDateRange.rangeStart &&
                    item.edit_at <= selectedDateRange.rangeEnd
                )

                return matchName && matchTable && matchCreatedBy && matchDate
            })
        },
        OpenModalHistoryTransactions()
        {
            const ids = this.stats.tables.flatMap(item => item.transactions);
            this.Loading();
            axios.post(`/transactions/${this.Local.id}/stats/deleted/products`, {
                ids: ids
            }).then( (res) => {

                const allItemsRes = res.data.sort((a, b) => b.edit_at - a.edit_at); 
                const tables = [...new Set(res.data.map(i => i.table))].map(value => ({text: value, value: value}))
                const itemNames = [...new Set(res.data.map(i => i.item_name))].map(value => ({text: value, value: value}))
                const createdBy = [...new Set(res.data.map(i => i.create_by))].map(value => ({text: value, value: value}))

                this.modalHistoryTransactions = {
                    allItems: allItemsRes,
                    visibleItems: [],
                    itemsNamesOptions: itemNames,
                    tablesOptions: tables,
                    createdBy: createdBy,
                    selectedDateRange: {
                        option: 'MONTH',
                        index: 0
                    },

                }
                this.Response(res);
            }).catch(err => {
                this.Response(err);
            });
        },
        OpenModalTransactionDetails(idTransaction){
            this.$refs.transactionDetails.Open(idTransaction);
        },
        CalculateTotalContributionMargin(stats) {
            if (!stats || typeof stats.total_money !== 'number') return 0;
            if (!stats.contribution_margin || typeof stats.contribution_margin.net_costs !== 'number') return 0;

            const totalSinIVA = stats.total_money / 1.19;
            const cost = stats.contribution_margin.net_costs;

            if (totalSinIVA === 0) {
                if (cost > 0) return -100;
                return 0;
            }

            const margin = ((totalSinIVA - cost) / totalSinIVA) * 100;

            return Math.floor(margin * 10) / 10;
        }
    },
    computed: {
        ordersOnlinePreviews() {
            if(this.comparingData) return [this.ordersOnlineCompare, this.ordersOnline];
            return [this.ordersOnline];
        },
        selectedTransactions() {
            var transactions = this.filter ? this.filter.transactions : this.data;
            var start = this.currentPage*25;
            var finish = Math.min(start + 25, transactions.length);
            return transactions.slice(start, finish);
        },
        totalPages() {
            var transactions = this.filter ? this.filter.transactions : this.data;
            return Math.ceil(transactions.length/25);
        },
        deliveryTransactions() {
            if(!this.stats) return null;
            for(var i = 0; i < this.stats.sale.length; i++)
            {
                if(this.stats.sale[i].data == 'DELIVERY') return this.stats.sale[i];
            }
            return null;
        },
        isLocal() {
            return this.Local.type == 'LOCAL';
        },
        previews() {
            let arr;
            if (this.comparingData && this.statsCompare) {
                arr = [
                    { stats: this.statsCompare, items: this.itemsCompare, label: 'Periodo comparado' },
                    { stats: this.stats, items: this.items, label: 'Periodo actual' },
                ];
            } else if (this.stats) {
                arr = [{ stats: this.stats, items: this.items, label: '' }];
            } else {
                arr = [];
            }
            return arr.filter(p => p && p.stats);
        }
    },
    watch: {
        currentTab: function(n, o) {
            this.currentDataPerTab = this.maxDataPerTab;
        }
    }
}
</script>

<style lang="scss">
.transactions-compare-panel {
    flex: 1 1 0;
    min-height: 0;
    min-width: 0;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
}

.transactions-compare-panel--split-mobile {
    height: 50%;
}

.transactions-compare-panel--divider-mobile {
    border-bottom: 2px solid var(--yellow);
}

.transactions-compare-panel--divider-desktop {
    border-right: 2px solid var(--yellow);
}

.transactions-range-sticky {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: var(--yellow); 
    color: var(--black); 
    border-radius: 0px 0px 5px 5px;
    margin-left: -10px;
    margin-right: -10px;
    cursor: pointer;
}

.img-round-mini {
    border-radius: 5px;
    width: 50px;
    height: 50px;
    margin-right: 10px;
    background-color: whitesmoke;
}
.percentage-icon {
    background-color: var(--gray-3);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--gray-1);
    font-weight: 500;
    font-size: 12px;
    flex-shrink: 0;
    text-shadow: 0px 0px 5px black;
}

.scroll-container {
    max-height: 300px;
    height: 300px;
    overflow-y: auto;
    padding: 10px;
    margin: -10px !important;
}

.dark {
    .percentage-icon {
        background-color: var(--dark-bg-2);
        color: var(--dark-fc-2);
    }
}

@media (max-width: 820px) {
    .scroll-container {
        padding: 0px;
        margin: 0px;
        height: auto;
    }
}

</style>
